import NoHotelProductsWarning from './NoHotelProductsWarning';
export default NoHotelProductsWarning;
